<router-outlet></router-outlet>
<div class="loader" [ngClass]="{ 'loader-active': loaderStatus }">
  <div class="loader-content">
    <mat-spinner [diameter]="25"></mat-spinner>
    <div class="loader-content-text">Please wait...</div>
  </div>
</div>
